import { styled } from '@mui/material';
import { colorPalettes } from '../../../context/theme';

export const StyledGitstreamLogo = styled('span')`
  display: flex;
  align-items: end;
  gap: 0.5rem;
`;
export const StyledBetaTag = styled('span')`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.BetaTag.color};
  background: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.BetaTag.background};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.7692rem;
  padding: 0 0.1rem;
  margin-bottom: 0.4rem;
`;
